import styles from "./index.module.css";
import Plyr from "plyr";
import "plyr-react/plyr.css";
import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { animated, useSpring } from "@react-spring/web";
import gsap from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);
const Video = (props, ref) => {
  const plyrRef = useRef(null);
  const volumeRef = useRef(null);
  const volumeTrackRef = useRef(null);
  const voiceIconSvgRef = useRef(null);
  const volumeProgressRef = useRef(1);
  const lastVolumeProgressRef = useRef(1);
  const mutedRef = useRef("progressSound");
  const volumeControlBoxRef = useRef(null);
  useEffect(() => {
    plyrRef.current = new Plyr(
      `#player${props.index}`,
      props.isMobile
        ? {
            controls: [
              "play",
              "current-time",
              "progress",
              "duration",
              "fullscreen",
              "settings",
            ],
            invertTime: false,
            fullscreen: {
              enabled: true,
              fallback: true,
              iosNative: true,
              container: null,
            },

            storage: false,

            quality: {
              default: 720,
              options: [720, 1080],
            },
          }
        : {
            controls: [
              "play",
              "current-time",
              "progress",
              "duration",
              "settings",

              // "fullscreen",
            ],
            invertTime: false,
            storage: false,
            fullscreen: {
              enabled: false,
              fallback: true,
              iosNative: false,
              container: null,
            },
            quality: {
              default: 1080,
              options: [720, 1080],
            },
          }
    );

    plyrRef.current.source = {
      type: "video",
      sources: [
        {
          src: `https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-home-0${
            props.index + 1
          }-m.mp4`,
          type: "video/mp4",
          size: 720,
        },
        {
          src: `https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-home-0${
            props.index + 1
          }-s-m.webm`,
          type: "video/webm",
          size: 720,
        },
        {
          src: `https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-home-0${
            props.index + 1
          }.mp4`,
          type: "video/mp4",
          size: 1080,
        },
      ],
      poster: props.movieData.videoBTSPosterSrc,
    };

    plyrRef.current.on("ended", (event) => {
      props.handlePlayToggle("play");
    });
  }, []);

  const [controlStyles, setControlStyles] = useSpring(() => ({
    opacity: 1,
    pointerEvents: "all",
    config: { tension: 280, friction: 60 },
  }));

  useImperativeHandle(ref, () => {
    return {
      playVideo,
      pauseVideo,
    };
  });

  const handleMute = () => {
    if (mutedRef.current === "clickMuted") {
      setVolume(undefined, lastVolumeProgressRef.current);
      mutedRef.current = "clickSound";
    } else if (
      mutedRef.current === "clickSound" ||
      mutedRef.current === "progressSound"
    ) {
      setVolume(undefined, 0);
      mutedRef.current = "clickMuted";
    } else if (mutedRef.current === "progressMuted") {
      setVolume(undefined, 1);
      mutedRef.current = "clickSound";
    }
  };
  const pauseVideo = () => {
    plyrRef.current.pause();
  };

  const playVideo = () => {
    plyrRef.current.play();
  };

  const handleVolumeCircleDown = () => {
    volumeRef.current = "click";
    volumeControlBoxRef.current.classList.add(styles.active);
  };

  const handleVolumeCircleMove = (e) => {
    if (volumeRef.current) {
      console.log(e);
      setVolume(e.clientX);
    }
  };

  const handleVolumeCircleUp = () => {
    volumeRef.current = null;
    volumeControlBoxRef.current.classList.remove(styles.active);
  };

  const handleVolumeTrackClick = (e) => {
    setVolume(e.clientX);
  };

  const setVolume = (x, progress) => {
    lastVolumeProgressRef.current = volumeProgressRef.current;
    if (progress !== undefined) {
      volumeProgressRef.current = progress;
    } else {
      let rect = volumeTrackRef.current.getBoundingClientRect();
      let p = (x - rect.left) / 176;
      volumeProgressRef.current = Math.min(Math.max(0, p), 1);
      if (volumeProgressRef.current === 0) {
        mutedRef.current = "progressMuted";
      } else {
        mutedRef.current = "progressSound";
      }
    }

    plyrRef.current.volume = volumeProgressRef.current;
    volumeTrackRef.current.style.setProperty(
      "--volume-progress",
      `${volumeProgressRef.current * 100}%`
    );
    if (volumeProgressRef.current > 0.5) {
      voiceIconSvgRef.current.setAttribute("shape", "big");
    } else if (volumeProgressRef.current > 0) {
      voiceIconSvgRef.current.setAttribute("shape", "small");
    } else {
      voiceIconSvgRef.current.setAttribute("shape", "close");
    }
  };

  const controlsHeight = props.isMobile ? 0 : 0;
  console.log(props.index);
  return (
    <animated.div
      className={styles.ctn}
      // onMouseEnter={props.handlePlayVisble}
      onMouseLeave={props.handlePlayHidden}
      onMouseMove={handleVolumeCircleMove}
      onMouseUp={handleVolumeCircleUp}
      style={{
        ...props.videoSpringStyles,
        "--video-width":
          props.movieData.proportion >=
          props.innerWidth / (props.innerHeight - controlsHeight * 2)
            ? "100vw"
            : `${
                (props.innerHeight - controlsHeight * 2) *
                props.movieData.proportion
              }px`,
        "--video-height":
          props.movieData.proportion >=
          props.innerWidth / (props.innerHeight - controlsHeight * 2)
            ? `${props.innerWidth / props.movieData.proportion}px`
            : `${props.innerHeight - controlsHeight * 2}px`,
        "--controls-top":
          props.movieData.proportion >=
          props.innerWidth / (props.innerHeight - controlsHeight * 2)
            ? `${
                (props.innerHeight -
                  props.innerWidth / props.movieData.proportion) /
                2
              }px`
            : `${0}px`,
        "--more-bottom":
          props.movieData.proportion >=
          props.innerWidth / (props.innerHeight - controlsHeight * 2)
            ? `${
                (props.innerHeight -
                  props.innerWidth / props.movieData.proportion) /
                2
              }px`
            : `${0}px`,
        "--controls-right":
          props.movieData.proportion >=
          props.innerWidth / (props.innerHeight - controlsHeight * 2)
            ? props.isMobile
              ? "24px"
              : "120px"
            : `${
                (props.innerWidth -
                  (props.innerHeight - controlsHeight * 2) *
                    props.movieData.proportion) /
                  2 +
                40
              }px`,
      }}
    >
      <animated.div className={styles.controls} style={{ ...controlStyles }}>
        <div
          className={styles.controlBox}
          onMouseEnter={props.handlePlayHidden}
          onMouseLeave={props.handlePlayVisble}
        >
          <div className={styles.volume}>
            <div
              className={styles.voiceIcon}
              // data-cursor-stick="#voice-icon"
              data-cursor-magnetic
              data-cursor-size="80px"
              onClick={handleMute}
            >
              <svg
                width="48"
                height="48"
                viewBox="0 0 48 48"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                id="voice-icon"
                className={styles.voiceIconSvg}
                ref={voiceIconSvgRef}
              >
                <mask id={`voice-icon-mask-${props.index}`}>
                  <rect width="48" height="48" fill="white" />
                  <path
                    d="M4 4L44 44"
                    stroke="black"
                    strokeWidth={6}
                    className="voice-close-path"
                  />
                </mask>
                <g
                  mask={`url(#voice-icon-mask-${props.index})`}
                  className="voice-an"
                >
                  <path
                    d="M31.5 14C32.7682 15.3132 33.7741 16.8722 34.4604 18.588C35.1468 20.3038 35.5 22.1428 35.5 24C35.5 25.8572 35.1468 27.6962 34.4604 29.412C33.7741 31.1278 32.7682 32.6868 31.5 34"
                    stroke="white"
                    className="voice-an1"
                  />
                  <path
                    d="M38.5 9C40.0852 10.9698 41.3426 13.3084 42.2005 15.8821C43.0584 18.4558 43.5 21.2142 43.5 24C43.5 26.7858 43.0584 29.5442 42.2005 32.1179C41.3426 34.6916 40.0852 37.0302 38.5 39"
                    stroke="white"
                    className="voice-an2"
                  />
                  <path
                    d="M14 31.5H4.5V16.5H14H14.181L14.3201 16.3841L25.5 7.0675V40.9325L14.3201 31.6159L14.181 31.5H14Z"
                    stroke="white"
                    className="voice-an3"
                  />
                </g>

                <path
                  d="M4 4L44 44"
                  stroke="white"
                  className="voice-close-path"
                />
              </svg>
            </div>
            <div
              className={styles.volumeControlBox}
              data-cursor-size="80px"
              ref={volumeControlBoxRef}
            >
              <div
                className={styles.volumeTrack}
                ref={volumeTrackRef}
                onClick={handleVolumeTrackClick}
              >
                <div
                  className={styles.volumeProgress}
                  style={{
                    width: `var(--volume-progress)`,
                  }}
                ></div>
                <div
                  className={styles.volumeControlCircle}
                  onMouseDown={handleVolumeCircleDown}
                ></div>
              </div>
            </div>
          </div>

          <div
            className={styles.closeIcon}
            // data-cursor-stick="#close-icon"
            data-cursor-magnetic
            data-cursor-size="80px"
            onClick={(e) => {
              props.closeVideo();
              props.handlePlayToggle("play");
            }}
          >
            <svg
              width="48"
              height="48"
              viewBox="0 0 48 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              id="close-icon"
            >
              <path d="M8 8L40 40M8 40L40 8" stroke="white" />
            </svg>
          </div>
        </div>
      </animated.div>

      <div
        className={styles.videoBox}
        data-cursor-size="120px"
        onClick={(e) => {
          console.log(e.target);
          console.log(plyrRef.current.elements);
          if (
            e.target === plyrRef.current.elements.poster ||
            e.target === plyrRef.current.elements.buttons.play[0]
          ) {
            if (props.isMobile) {
              if (e.target !== plyrRef.current.elements.buttons.play[0]) {
                plyrRef.current.togglePlay();
              }
            } else {
              props.handlePlayToggle();
            }
          }
        }}
        onMouseLeave={() => {
          console.log("Leave");
          if (!props.isMobile) {
            props.handlePlayHidden();
          }
        }}
        onMouseMove={(e) => {
          if (e.target !== plyrRef.current.elements.poster) {
            if (!props.isMobile) {
              props.handlePlayHidden();
            }
          } else {
            if (!props.isMobile) {
              props.handlePlayVisble();
            }
          }
        }}
        onMouseEnter={props.handlePlayVisble}
        // data-cursor-background-image="https://reactjs.org/logo-og.png"
      >
        <video
          playsInline
          id={`player${props.index}`}
          onCanPlayThrough={(e) => {
            props.setLoadProgressState();
          }}
          ref={plyrRef}
        ></video>
      </div>

      <div className={styles.more}>
        <div className={styles.moreContent}>
          <div
            className={styles.moreContentText}
            data-cursor-size="120px"
            onClick={() => {
              gsap.to(window, {
                duration: 0.6,
                scrollTo: {
                  y: `.sm5s-ssp-detail-ctn-${props.index}`,
                  offsetY: props.isMobile ? 120 : 160,
                },
              });
            }}
          >
            <div>Scroll for details</div>

            <svg
              width="31"
              height="30"
              viewBox="0 0 31 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M27.5 11L15.5 23L3.5 11" stroke="white" />
            </svg>
          </div>
        </div>
      </div>
    </animated.div>
  );
};

export default forwardRef(Video);
